<template>
    <div class="content-question" v-html="html"></div>
</template>
<script>
import { sanitizeRichText } from "../../utils/rich-text";

export default {
    name: "content-question",
    props: {
        body: {
            type: String,
            default: "",
        },
    },
    computed: {
        html() {
            return sanitizeRichText(this.body);
        },
    },
    methods: {
        // A content block never collects an answer, but the step still walks the
        // same refs as every other question.
        getValue: function () {
            return null;
        },
        isValid: function () {
            return true;
        },
        isNull: function () {
            return true;
        },
    },
};
</script>
